/**
 * @generated SignedSource<<40a9b1b35e96896444397cd77791fa4d>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useShortcutsSpaceNavigationQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useShortcutsSpaceNavigationQuery$data = {
  readonly spaceSidebarLinks: {
    readonly __typename: "SpaceSidebarLinks";
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useShortcutsSpaceNavigationQuery = {
  response: useShortcutsSpaceNavigationQuery$data;
  variables: useShortcutsSpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "SpaceSidebarLinks",
    "kind": "LinkedField",
    "name": "spaceSidebarLinks",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "quick",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "position"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "styleClass"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useShortcutsSpaceNavigationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useShortcutsSpaceNavigationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
    "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
    "metadata": {},
    "name": "useShortcutsSpaceNavigationQuery",
    "operationKind": "query",
    "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
  }
};
})();

(node as any).hash = "52dba71769af710a3e1e472bed635436";

export default node;
